<script>
import axios from 'axios';
import utilsService from '@/api/utilsService';
const apiUrl = `${process.env.VUE_APP_API_URL}/api/actas`;
const token = utilsService.getToken();

const actaService = {

  async getActa(ingreso) {
    try {
      const response = await axios.get(`${apiUrl}/generar-acta/${ingreso}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },        
        responseType: 'blob',
      });

      const disposition = response.headers['content-disposition'];
      let fileName = `reporte_material_${new Date().toISOString().slice(0, 10)}.pdf`;
      if (disposition && disposition.includes('filename=')) {
        const fileNameMatch = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (fileNameMatch && fileNameMatch[1]) {

          fileName = fileNameMatch[1].replace(/['"]/g, '');
        }
      }

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);

    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data || 'Error al crear el ingreso.');
      } else {
        throw new Error(error.message || 'Error en la solicitud.');
      }

    }
  },
  async anularActa(ingreso) {
    try {
      const response = await axios.delete(`${apiUrl}/anular-acta/${ingreso}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.status;
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || 'Error al anular acta.');
      } else {
        throw new Error(error.message || 'Error en la solicitud.');
      }

    }
  },



};

export default actaService;
</script>